import { Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as InfoIcon } from "@king-ict/eupisi-ui/components/Icon/Info.svg";
import { Col } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { useTranslation } from "react-i18next";

import { useTypedSelector } from "../../app";
import styles from "./Navigation.module.scss";

export const Navigation = () => {
  const importantDate = useTypedSelector((s) => s.application.importantDate);

  const user = useTypedSelector((s) => s.application.user);
  const institutionDetails = useTypedSelector((s) => s.application.institutionDetails);
  const { t } = useTranslation();

  return (
    <>
      <Navbar className={styles.navbar} expand="sm">
        {(importantDate?.eventName || user.roleName) && (
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className={styles.eventContent}>
              <div className={styles.icon}>
                <InfoIcon />
              </div>
              <Typography
                variant="baseBold"
                color="base"
                className={styles.eventText}
              >
                {`${t("common.activeRole", {
                  role: user?.roleName ?? "-",
                })} | ${t("common.activeEvent", {
                  event: importantDate?.eventName ?? "-",
                })}
                | ${t("common.activeKindergarten", {
                  kindergartenName: institutionDetails?.institutionName ?? "Skupna razina",
                })}
                | ${t("common.activeTown", {
                  town: institutionDetails?.townName ?? "-",
                })}
                   `}
              </Typography>
            </div>
          </Col>
        )}
      </Navbar>
    </>
  );
};
